import { z } from 'zod';
import { ArtistIdSchema, IsoDateSchema, TrackIdSchema } from './common.js';
export const ReleaseOverrideSchema = z.object({
    artistId: ArtistIdSchema,
    trackId: TrackIdSchema,
    title: z.string().nullable(),
    /** What Luminate holds, as stored (possibly partial). */
    luminateDate: z.string().nullable(),
    releaseDate: IsoDateSchema,
    source: z.string().nullable(),
    note: z.string().nullable(),
    updatedBy: z.string(),
    updatedAt: z.iso.datetime(),
});
export const ReleaseOverrideInputSchema = z.object({
    releaseDate: IsoDateSchema,
    source: z.url().max(2000).optional(),
    note: z.string().max(1000).optional(),
});
//# sourceMappingURL=overrides.js.map